import type { RouteObject } from 'react-router';
import { PantryPage } from './PantryPage';

/** Routes for the pantry area (mounted inside RequireHousehold). */
export const pantryRoutes: RouteObject[] = [{ path: '/pantry', element: <PantryPage /> }];
